<template>
  <div id="nav">
    <div id="header" class="block">
      <div>
        <div style="display: inline-block; width: 250px;">
          <img
            src="https://image.fantasy-tours.com/Content/Images/Layout/index/logo.png"
            alt=""
          />
        </div>
        <div class="control-list-title">
          線別團控
        </div>
      </div>
      <img
        src="https://image.fantasy-tours.com/html/images/fantasycontrol_02.jpg"
        alt=""
      />
    </div>
    <div id="tour-control-map" class="block">
      <div class="areas">
        <p>
          <a
            href="https://docs.google.com/spreadsheets/d/1zuFqFNi-R7VEbx0YilxM2DJBgUyjRnxi/edit#gid=271376244"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <span class="area-main">團體說明會時間</span>
            <span class="control-list">上順團體說明會登記表</span>
          </a>
        </p>
      </div>
      <div class="areas">
        <p>
          <a
            href="https://docs.google.com/spreadsheets/d/1wrJiebOvxjrOZEIgAXccPE1bC_giFo5a5Fx6Fi5iUbI/edit?usp=sharing"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <span class="area-main">郵輪/河輪</span>
            <span class="control-list">團控表</span>
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/cruise/"
            target="_blank"
          >
            郵輪館
          </a>
        </p>
      </div>
      <div class="areas">
        <p>
          <a
            href="https://docs.google.com/spreadsheets/d/1mj1QDDhz2TGJYIEOJE5GAvRbp50hawZlSd3aAqhq5tA/edit?usp=sharing"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <span class="area-main">日韓線</span>
            <span class="control-list">日本團控表</span>
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/japan/"
            target="_blank"
          >
            日本館
          </a>
          ｜
          <input
            type="hidden"
            id="舊韓國團控表"
            value="https://docs.google.com/spreadsheets/d/18JbnNQ6zSusDS4KqJKG-_IrksjbRS3er0xOjoZcbjXA/pubhtml"
          />
          <a class="control-list" style="cursor: default;">
            韓國團控表
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/japan/j20/"
            target="_blank"
          >
            韓國館
          </a>
        </p>
      </div>
      <div class="areas">
        <p>
          <a
            href="https://docs.google.com/spreadsheets/d/1rsdCJshlSKtViGQeimgCiKJMZyZICTK3/"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <span class="area-main">歐洲</span>
            <span class="control-list">團控表</span>
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/europe/"
            target="_blank"
          >
            歐洲館
          </a>
        </p>
      </div>
      <div class="areas">
        <p>
          <a
            href="https://docs.google.com/spreadsheets/d/1LY-c90hnEl_sMdvNcAdCoo4uPgbMcNGc/"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <span class="area-main">南非/北非/印度/杜拜/中南美洲</span>
            <span class="control-list">團控表</span>
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/africa/kza/"
            target="_blank"
          >
            南非館
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/africa/naf/"
            target="_blank"
          >
            北非館
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/southasia/ind/"
            target="_blank"
          >
            印度館
          </a>
        </p>
      </div>
      <div class="areas">
        <p>
          <a
            href="https://docs.google.com/spreadsheets/d/1wL_Xi6UnOgHpjlEwqOjfttLhT1UD6Nac1yZgXn4J8WI/edit?usp=sharing"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <span class="area-main">紐澳線</span>
            <span class="control-list">團控表</span>
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/newzealand/a1a/"
            target="_blank"
          >
            紐西蘭館
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/newzealand/a1u/"
            target="_blank"
          >
            澳洲館
          </a>
        </p>
      </div>
      <div class="areas">
        <p>
          <a
            href="https://docs.google.com/spreadsheets/d/1OumMWH9twucqv0Iiras5PXElmmAFx8w8Rg1pxkqse40/edit?usp=sharing"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <span class="area-main">東非/南極/土耳其</span>
            <span class="control-list">團控表</span>
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/africa/a1m/"
            target="_blank"
          >
            東非館
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/aroundworld/ata/"
            target="_blank"
          >
            南極館
          </a>
          ｜
          <a
            class="web-site"
            href="https://www.fantasy-tours.com/travel/africa/tuk/"
            target="_blank"
          >
            土耳其館
          </a>
        </p>
      </div>
      <div class="areas">
        <div class="area-pair">
          <p>
            <a
              href="https://docs.google.com/spreadsheets/d/1JbwdDm_O0EazW1RU1Yi00vp-Z2YnQdzRvuPofKpEb_4/edit?usp=sharing"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <span class="area-main">東南亞</span>
              <span class="control-list">團控表</span>
            </a>
            ｜
            <a
              class="web-site"
              href="https://www.fantasy-tours.com/travel/southasia/"
              target="_blank"
            >
              東南亞館
            </a>
          </p>
        </div>
        <div class="area-pair"></div>
      </div>
      <div class="areas">
        <div class="area-pair">
          <p>
            <a
              href="https://docs.google.com/spreadsheets/d/17MFohbGWQKYW_rZOnfwJabYhh1_3Rrnu64DV65oxFd8/edit?usp=sharing"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <span class="area-main">美加線</span>
              <span class="control-list">團控表</span>
            </a>
            ｜
            <a
              class="web-site"
              href="https://www.fantasy-tours.com/travel/america/"
              target="_blank"
            >
              美加館
            </a>
          </p>
        </div>
        <div class="area-pair">
          <p>
            <a
              href="https://docs.google.com/spreadsheets/d/1VUef_Kbk4amF0AW9FYM3ZMh3y-TmElLP/"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <span class="area-main">中國大陸</span>
              <span class="control-list">團控表</span>
            </a>
            ｜
            <a
              class="web-site"
              href="https://www.fantasy-tours.com/travel/china/"
              target="_blank"
            >
              中國大陸館
            </a>
          </p>
        </div>
      </div>
    </div>
    <div id="footer" class="block">
      <img
        src="https://image.fantasy-tours.com/html/images/fantasycontrol_11.jpg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TourControlMap'
}
</script>
<style>
.block {
  max-width: 792px;
  height: auto;
  margin: 0 auto;
  position: relative;
}
.control-list-title {
  display: inline-block;
  width: 200px;
  font-size: 3em;
  text-align: right;
  color: #07406d;
  font-weight: 600;
  font-family: 'Helvetica Neue', '微軟正黑體', Helvetica, Arial, sans-serif !important;
}
.areas {
  line-height: 45px;
  display: inline;
}

.areas:nth-child(even) p {
  background-color: #f2f2f2;
}

.area-pair {
  width: 50%;
  display: inline-block;
}
.area-main {
  color: #880d82;
  font-size: 26px;
  font-weight: 600;
  margin: 0 15px;
  font-family: 'Helvetica Neue', '微軟正黑體', Helvetica, Arial, sans-serif !important;
}
.areas p a svg {
  width: 24px;
  height: 24px;
  font-size: 26px;
  background-color: #f8b51c;
  border-radius: 0.5em;
  color: #fff;
}
.control-list {
  color: #000000;
  font-size: 17px;
  font-weight: 600;
  font-family: 'Helvetica Neue', '微軟正黑體', Helvetica, Arial, sans-serif !important;
}
.web-site {
  color: #898989;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Helvetica Neue', '微軟正黑體', Helvetica, Arial, sans-serif !important;
}
</style>
